require('../styles/transitions.less');

module.exports = {
    addBtn: 'btn btn-xs btn-default btn-add',
    iconAdd: "icon-add"
}


/** WEBPACK FOOTER **
 ** ./src/styles/CollectionMixin-style.js
 **/